import React from "react";
import {
  Modal,
  Form,
  Typography,
} from "antd";

const { Text } = Typography;

const SendPasswordResetEmailModal = ({
    loading,
    visible,
    onOk,
    onCancel,
    title,
    okText,
    email,
  }) => {
    const [form] = Form.useForm();
    
    return (
      <Modal
        destroyOnClose={true}
        okButtonProps={{ loading: loading }}
        cancelButtonProps={{ disabled: loading }}
        maskClosable={false}
        visible={visible}
        title={title}
        okText={okText}
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          onOk();
        }}
      >
        <div>
          This will send a password reset email to <Text mark>{email}</Text>. Continue?
        </div>
      </Modal>
    );
};

export default SendPasswordResetEmailModal;